import { graphql } from "~/gql";

export const BEDROCK_START_STREAMING_CLARIFYING_QUESTIONS = graphql(/* GraphQL */ `
  mutation BedrockStartStreamingClarifyingQuestions($matterTitle: String!, $countryCode: String) {
    bedrockStartStreamingClarifyingQuestions(matterTitle: $matterTitle, countryCode: $countryCode) {
      sessionId
      success
    }
  }
`);

export const STREAMING_CLARIFYING_QUESTIONS_SUBSCRIPTION = graphql(/* GraphQL */ `
  subscription StreamingClarifyingQuestions($sessionId: String!) {
    streamingClarifyingQuestions(sessionId: $sessionId) {
      sessionId
      eventType
      question {
        id
        label
        allowOther
        otherPlaceholder
        options {
          label
          value
        }
      }
      error
      totalQuestions
      currentQuestionIndex
    }
  }
`);
